/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterPermissionsDtoSchema = z.object({
  canInvite: z.optional(z.boolean()),
  canKick: z.optional(z.boolean()),
  canChangeRoles: z.optional(z.boolean()),
  canChangeCaptain: z.optional(z.boolean()),
  canEditTeam: z.optional(z.boolean()),
});
